import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const REV_COLOR = "#378ADD";
const UNIT_COLOR = "#1D9E75";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg px-3 py-2 text-xs">
      <p className="font-semibold text-gray-700 mb-1.5 border-b border-gray-100 pb-1">{label || payload[0]?.payload?.sub_category}</p>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center gap-1.5 mt-1">
          <span className="w-2 h-2 rounded-full" style={{ background: p.color }} />
          <span className="text-gray-500">
            {p.dataKey === "revenue_raw" ? "Revenue" : "Units"}:
          </span>
          <span className="font-semibold text-gray-700">
            {p.dataKey === "revenue_raw" ? p.payload.revenue : p.payload.units}
          </span>
        </div>
      ))}
    </div>
  );
};

const CategoryChart = ({ categoryWise }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4">
    <div className="flex items-center justify-between mb-3">
      <p className="text-xs font-semibold text-gray-700 uppercase tracking-wider">Sub-category-wise Sales</p>
      <div className="flex items-center gap-3 text-xs text-gray-500">
        <span className="flex items-center gap-1">
          <span className="w-2.5 h-2.5 rounded-sm inline-block" style={{ background: REV_COLOR }} />
          Revenue
        </span>
        <span className="flex items-center gap-1">
          <span className="w-2.5 h-2.5 rounded-sm inline-block" style={{ background: UNIT_COLOR }} />
          Units
        </span>
      </div>
    </div>

    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={categoryWise} margin={{ top: 2, right: 16, left: 0, bottom: 36 }} barGap={2} barCategoryGap="30%">
        <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" vertical={false} />
        <XAxis
          dataKey="sub_category"
          tick={{ fontSize: 10, fill: "#9ca3af" }}
          angle={-25}
          textAnchor="end"
          interval={0}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          yAxisId="left"
          tickFormatter={(v) => `₹${(v / 100000).toFixed(0)}L`}
          tick={{ fontSize: 10, fill: "#9ca3af" }}
          width={44}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          tick={{ fontSize: 10, fill: "#9ca3af" }}
          width={28}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "#f9fafb" }} />
        <Bar yAxisId="left" dataKey="revenue_raw" fill={REV_COLOR} radius={[3, 3, 0, 0]} />
        <Bar yAxisId="right" dataKey="units" fill={UNIT_COLOR} radius={[3, 3, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default CategoryChart;
